import { call, put, takeLatest } from "redux-saga/effects";
import {
  addContact,
  addNewClient,
  fetchClients,
  fetchOneClient,
  updateClient,
  updateContact,
} from "./clientApi";

import {
  getClientsStart,
  getClientsSuccess,
  getClientsFailure,
  updateClientStart,
  updateClientSuccess,
  updateClientFailure,
  addContactSuccess,
  addContactFailure,
  addContactStart,
  getClientOneSuccess,
  getClientOneFailure,
  getClientOneStart,
  updateContactSuccess,
  updateContactFailure,
  updateContactStart,
} from "./clientSlice";

import {
  addNewClientStart,
  addNewClientSuccess,
  addNewClientFailure,
} from "./clientSlice";
import { showToast } from "../../../components";
function* fetchClientsSaga(action) {
  try {
    const clients = yield call(fetchClients, action.payload);
    yield put(getClientsSuccess(clients));
  } catch (error) {
    yield put(getClientsFailure(error.message));
  }
}
function* fetchOneClientSaga(action) {
  try {
    const clients = yield call(fetchOneClient, action.payload);
    yield put(getClientOneSuccess(clients.data));
  } catch (error) {
    yield put(getClientOneFailure(error.message));
  }
}
function* addNewClientSaga(action) {
  try {
    const response = yield call(addNewClient, action.payload);
    if (response.success) {
      yield put(addNewClientSuccess(response.data));
      if (action.payload.onSuccess) {
        action.payload.onSuccess(response.data);
      }
      showToast("Client Added Successfully", "success", 3000);
    } else {
      yield put(addNewClientFailure(response.error));
      showToast(`${response?.error?.errorResponse?.errmsg ? response?.error?.errorResponse?.errmsg : response?.error }`, "error", 3000);
    }
  } catch (error) {
    yield put(addNewClientFailure(error.message));
    showToast("Client Failed To Add", "error", 3000);
  }
}
function* updateClientSaga(action) {
  try {
    const { onSuccess, suppressToast = false, ...payload } = action.payload;
    const response = yield call(updateClient, payload);
    if (response.success) {
      yield put(updateClientSuccess(response.data.data));
      onSuccess(response.data.data);
      if (!suppressToast) {
        showToast("Client Updated Successfully", "success", 3000);
      }
    } else {
      yield put(updateClientFailure(response.error));
      showToast(`${response.error}`, "error", 3000);
    }
  } catch (error) {
    yield put(updateClientFailure(error));
  }
}
function* addNewContactSaga(action) {
  try {
    const { submissionData, onSuccess } = action.payload;
    const response = yield call(addContact, submissionData);
    if (response.success) {
      yield put(addContactSuccess(response.data));
      onSuccess();
      showToast("Added Contact Successfully", "success", 3000);
    } else {
      yield put(addContactFailure(response.error));
      showToast(`${response.error}`, "error", 3000);
    }
  } catch (error) {
    yield put(addContactFailure(error.message));
  }
}

function* updateContactSaga(action) {
  try {
    const response = yield call(updateContact, action.payload);
    if (response.success) {
      yield put(updateContactSuccess(response.data));
      showToast("Updated Contact Successfully", "success", 3000);
    } else {
      yield put(updateContactFailure(response.error));
      showToast(`${response.error}`, "error", 3000);
    }
  } catch (error) {
    yield put(updateContactFailure(error.message));
  }
}

export function* watchFetchClients() {
  yield takeLatest(getClientsStart.type, fetchClientsSaga);
  yield takeLatest(addNewClientStart.type, addNewClientSaga);
  yield takeLatest(updateClientStart.type, updateClientSaga);
  yield takeLatest(addContactStart.type, addNewContactSaga);
  yield takeLatest(updateContactStart.type, updateContactSaga);
  yield takeLatest(getClientOneStart.type, fetchOneClientSaga);
}
